import type { SourceValue } from '../sources';

export const getFiltersKey = (filters: SourceValue['filters'] | undefined) => {
  if (!filters) {
    return [];
  }

  const filtersList = filters.reduce<string[]>((acc, filter) => {
    const filterValue =
      typeof filter.filterValue === 'object'
        ? JSON.stringify(filter.filterValue)
        : filter.filterValue;

    if (filterValue) {
      acc.push(`${filter.id}-${filterValue}`);
    }

    return acc;
  }, []);

  return filtersList;
};
